import React from 'react';
import {GptSummarization} from '@store/call-card/Call';
import './CallCardSummary.sass';
import GenericLink from 'components/GenericLink';
import ToastActions from '@store/toast/ToastActions';

interface CallCardSummaryProps {
  gpt: GptSummarization;
}

export const CallCardSummary: React.FC<CallCardSummaryProps> = ({gpt}) => {
  const summary = gpt.summary && (
    <div className="summary">
      <h4>Summary ✨</h4>
      <p>{gpt.summary}</p>
    </div>
  );

  const nextSteps = gpt.nextSteps && gpt.nextSteps.length > 0 && (
    <div className="next-steps">
      <div className="next-steps-header">
        <h4>Next Steps ✨</h4>
        <GenericLink
          className="clipboard-copy"
          onClick={() => {
            navigator.clipboard
              .writeText(gpt.nextSteps.map((step, i) => `${i + 1}: step`).join('\n\n'))
              .then(() =>
                ToastActions.addToast({
                  message: 'Copied next steps to clipboard',
                })
              );
          }}>
          Copy to clipboard
        </GenericLink>
      </div>
      {gpt.nextSteps.map((nextStep, i) => (
        // I'd really like to use a normal <ol> here, but theres no way to
        // add spacing between the number and the content. Please update if that changes
        <div key={i} className="step-list-item">
          <div className="list-counter">{i + 1}.</div>
          <div className="step-content">{nextStep}</div>
        </div>
      ))}
    </div>
  );

  const qa = gpt.qa && gpt.qa.length > 0 && (
    <div className="summary-qa">
      <h4>Questions & Answers ✨</h4>
      <div className="qa-pair-list">
        {gpt.qa.map(({answer, question}, i) => (
          <div key={i} className="qa-pair">
            <div className="summary-question">{question}</div>
            <div className="summary-answer">{answer}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="call-card-summary">
      <div className="lg">
        <div className="summary-qa">
          {summary}
          {qa}
        </div>
        {nextSteps}
      </div>
      <div className="sm">
        {summary}
        {nextSteps}
        {qa}
      </div>
    </div>
  );
};
